export default "__VITE_ASSET__BJN2uUr$__"